import moment from 'moment'
import { createContext, useContext } from 'react'

import { useAuth } from '../../Shared/Contexts/AuthContext'

const StatisticsContext = createContext({})

export const useStatistics = () => {
  return useContext(StatisticsContext)
}

export const StatisticsProvider = ({ children }) => {
  const { useBaseAxiosGet, useBaseDownload } = useAuth()

  const addDateRangeToUrl = (url, from, to) => {
    const start = moment.utc(from).startOf('day').toISOString()
    const end = moment.utc(to).endOf('day').toISOString()
    const separator = url.includes('?') ? '&' : '?'
    return `${url}${separator}dateFrom=${start}&dateTo=${end}`
  }

  const useFetchSingleOrganizationStatistics = async ({ payload: { organizationKeys = [], dateRange } }) => {
    const url = addDateRangeToUrl(
      organizationKeys && organizationKeys.length > 0
        ? `/thresholds/statistics?organizationKeys=${organizationKeys}`
        : '/thresholds/statistics',
      dateRange?.from,
      dateRange?.to
    )
    return await useBaseAxiosGet({ url })
  }

  const useFetchRootOrganizationStatistics = async ({ payload: { organizationKeys = [], dateRange } }) => {
    const url = addDateRangeToUrl(
      organizationKeys && organizationKeys.length > 0
        ? `/thresholds/statistics?organizationKeys=${organizationKeys.join(',')}`
        : '/thresholds/statistics',
      dateRange?.from,
      dateRange?.to
    )
    return await useBaseAxiosGet({ url })
  }

  const useExportStatistics = async ({ payload: { organizationKeys = [], dateRange } }) => {
    const url = addDateRangeToUrl(
      organizationKeys && organizationKeys.length > 0
        ? `/thresholds/statistics-export?organizationKeys=${organizationKeys.join(',')}`
        : '/thresholds/statistics-export',
      dateRange?.from,
      dateRange?.to
    )
    return useBaseDownload({
      method: 'get',
      url: url
    }).then((response) => saveAs(response.data, 'statistics-export.xlsx'))
  }

  const value = { useFetchSingleOrganizationStatistics, useFetchRootOrganizationStatistics, useExportStatistics }

  return <StatisticsContext.Provider value={value}>{children}</StatisticsContext.Provider>
}
